export enum ProductActionTypes {
  API_RESPONSE_SUCCESS = '@@product/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@product/API_RESPONSE_ERROR',

  LIST_PRODUCTS = '@@product/LIST_PRODUCTS',
  SYNC_PRODUCT = '@@product/SYNC_PRODUCT',
  DELETE_PRODUCT = '@@product/DELETE_PRODUCT',

  RESET = '@@product/RESET',
}